
import { $http } from './http.js';
import qs from 'qs';

const _str = obj => qs.stringify(obj);
const _isAll = true;
const isNoToken = true;
const isCustomUrl = true;
const config = {
  // 登录
  Login (data) {
    return $http({url: '/zpuser/userLogin', data: _str(data), isNoToken}).post();
  },
  // 业务员登陆
  salesmanLogin (data) {
    return $http({url: '/salesman/login ', data: _str(data), isNoToken}).post();
  },
  // 用户注册
  Reg (data) {
    return $http({ url: '/zpuser/userRegister', data: _str(data), isNoToken }).post();
  },
  // 新用户注册
  Regnew (data) {
    return $http({ url: '/zpuser/userRegisters', data: _str(data), isNoToken }).post();
  },
  // 新用户订单号
  OrderCart (data) {
    return $http({ url: '/zpshoporder/insertOrderCart', data: _str(data), isNoToken }).post();
  },
  // 发送短信(图形验证码)
  sendSmsVerifier (data) {
    return $http({ isNoToken, _isAll, url: '/zpsms/sendSmsVerifier', data: _str(data) }).post();
  },
  // 发送短信验证码
  sendSmsCode (data) {
    return $http({ isNoToken, _isAll, url: '/zpsms/sendSmsIgnore', data: _str(data) }).post();
  },
  getUserInfo (data) {
    return $http({ url: '/zpuser/userMsgs', data: _str(data) }).post();
  },
  // 订单分页查询
  orderByPage (data) {
    return $http({ url: '/zpshoporder/orderByPage', data: _str(data) }).post();
  },
  getWeiJs (data) {
    return $http({ url: '/zpuser/getWeiJs', data: _str(data) }).post();
  },
  // 订单详情
  /* orderMsg (data) {
    return $http({ url: '/zpshoporder/orderMsg', data: _str(data) }).post();
  }, */
  orderMsg (data) {
    return $http({ url: '/zpuserwithdraw/selectzpShopOrderById', data: _str(data) }).post();
  },
  // 收益列表
  incomeByPage (data) {
    return $http({ url: '/zpuserincome/incomeByPage', data: _str(data) }).post();
  },
  // 提现个人判断身份证
  findCardByUserId (data) {
    return $http({ url: '/zpuserbank/findCardByUserId', data: _str(data) }).post();
  },
  // 提现个人判断身份证正反照
  IdCardInsert (data) {
    return $http({ url: '/zpuserbank/IdCardInsert', data: _str(data) }).post();
  },
  SweepOrder (data) {
    return $http({ url: '/zjAggregatePayment/toSweepOrder', data: _str(data) }).post();
  },
  getOpenId (data) {
    return $http({ url: '/zjAggregatePayment/getOpenId.xhtml', data: _str(data) }).get();
  },
  // 我的收支列表（分页）
  zpUserBill (data) {
    return $http({ url: '/zpuser/zpUserBill', data: _str(data) }).post();
  },
  // 提现详情
  userWithdrawById (data) {
    return $http({ url: '/zpuserwithdraw/userWithdrawById', data: _str(data) }).post();
  },
  // 收益详情
  incomeById (data) {
    return $http({ url: '/zpuserincome/incomeById', data: _str(data) }).post();
  },
  signature (data) {
    return $http({ url: '/zpuser/signature', data: _str(data) }).post();
  },
  // 用户银行卡分页
  bankByPage (data) {
    return $http({ url: '/zpuserbank/bankByPage', data: _str(data) }).post();
  },
  // 解绑银行卡
  bankUnbind (data) {
    return $http({ url: '/zpuserbank/bankUnbind', data: _str(data) }).post();
  },
  // 查询银行卡类型
  getBankType (data) {
    return $http({ url: '/banktype/getBankType', data: _str(data) }).post();
  },
  // 用户添加银行卡（发送短信）
  bankInsert (data) {
    return $http({ url: '/zpuserbank/bankInsert', data: _str(data) }).post();
  },
  // 用户添加银行卡（验证短信并绑定）
  bankValid (data) {
    return $http({ url: '/zpuserbank/bankValid', data: _str(data) }).post();
  },
  // 用户添加银行卡（验证短信并绑定）
  findByDefault (data) {
    return $http({ url: '/zpuserbank/findByDefault', data: _str(data) }).post();
  },
  // 用户基本资料修改
  updateUser (data) {
    return $http({ url: '/zpuser/updateUser', data: _str(data) }).post();
  },
  // 图片上传
  upload (data) {
    return $http({ url: '/file/upload', data }).post();
  },
  // 图片上传
  uploadList (data) {
    return $http({ url: '/file/uploadList', data }).post();
  },
  // 提现分页列表
  userWithdrawByPage (data) {
    return $http({ url: '/zpuserwithdraw/getPartnerPriceListByPage', data: _str(data) }).post();
  },
  // 提交意见反馈
  sendComplaint (data) {
    return $http({ url: '/complaint/sendComplaint', data: _str(data) }).post();
  },
  // 查询水机详情信息
  commodityMsg (data) {
    return $http({ url: '/zpshopcommodity/commodityMsg', data: _str(data) }).post();
  },
  // 获取商品接口
  shopByPage (data) {
    return $http({ url: '/zpshoptype/shopByPage', data: _str(data) }).post();
  },
  // 改变商品类别
  updateShopType (data) {
    return $http({ url: '/zpshoporder/updateShopType', data: _str(data) }).post();
  },
  // 商品加入购物车(下单1)
  getOrderCart (data) {
    return $http({ url: '/zpshoporder/getOrderCart', data: _str(data) }).post();
  },
  // 根据订单号查询订单
  orderByNumber (data) {
    return $http({ url: '/zpshoporder/orderByNumber', data: _str(data) }).post();
  },
  // 发票确认
  updateInvoiceInfo (data) {
    return $http({ url: '/zpshoporder/updateInvoiceInfo', data: _str(data) }).post();
  },
  // 发票信息回显
  selectInvoiceInfo (data) {
    return $http({ url: '/zpshoporder/selectInvoiceInfo', data: _str(data) }).post();
  },
  // 发票信息回显
  getPaymentChannelOptions (data) {
    return $http({ url: '/zpshoporder/paymentChannelInfo', data: _str(data) }).post();
  },
  // 下单发送短信验证码(下单2)
  getOrder (data) {
    return $http({ url: '/zpshoporder/getOrder', data: _str(data) }).post();
  },
  // 验证短信并支付(下单3)
  getPayOrder (data) {
    return $http({ url: '/zpshoporder/getPayOrder', data: _str(data) }).post();
  },
  // 提现
  userWithdrawInsert (data) {
    return $http({ url: '/zpuserwithdraw/userWithdrawInsertCheck', data: _str(data) }).post();
    /* return $http({ url: '/zpuserwithdraw/userWithdrawInsert', data: _str(data) }).post(); */
  },
  // 获取用户默认收货地址
  userAddressDefault (data) {
    return $http({ url: '/zpuaddress/userAddressDefault', data: _str(data), _isAll }).post();
  },
  // 添加收货地址
  userAddressAdd (data) {
    return $http({ url: '/zpuaddress/userAddressAdd', data: _str(data) }).post();
  },
  // 我的收货地址列表
  userAddressByPage (data) {
    return $http({ url: '/zpuaddress/userAddressByPage', data: _str(data) }).post();
  },
  // 修改收货地址
  userAddressUpdate (data) {
    return $http({ url: '/zpuaddress/userAddressUpdate', data: _str(data) }).post();
  },
  // 删除收货地址
  userAddressDelete (data) {
    return $http({ url: '/zpuaddress/userAddressDelete', data: _str(data) }).post();
  },
  // 收货地址详情
  userAddressMsg (data) {
    return $http({ url: '/zpuaddress/userAddressMsg', data: _str(data) }).post();
  },
  // 用户积分修改记录
  findByIntrgralList (data) {
    return $http({ url: '/integral/findByIntrgralList', data: _str(data) }).post();
  },
  // 查看举荐人列表
  findByRecPid (data) {
    return $http({ url: '/rec/findByRecPid', data: _str(data) }).post();
  },
  // 查看举荐人列表4
  findfreeUserByTzs (data) {
    return $http({ url: '/rec/findfreeUserByTzs', data: _str(data) }).post();
  },
  // 查看积分
  findIntrgraByUserId (data) {
    return $http({ url: '/integral/findIntrgraByUserId', data: _str(data) }).post();
  },
  // 查看免费积分
  findfreeInteger (data) {
    return $http({ url: '/rec/findfreeInteger', data: _str(data) }).post();
  },
  // 举荐人收款确认
  payMoneyUnderLine (data) {
    return $http({ url: '/rec/payMoneyUnderLine', data: _str(data) }).post();
  },
  // 我的分公司信息
  findByUserCard (data) {
    return $http({ url: '/zpbranch/findByUserCard', data: _str(data) }).post();
  },
  salesmanMsg (data) {
    return $http({ url: '/salesman/getMsg', data: _str(data) }).post();
  },
  salesmangetDetailByPage (data) {
    return $http({ url: '/salesman/getDetailByPage', data: _str(data) }).post();
  },
  SalesmanPassword (data) {
    return $http({ url: '/salesman/managerSalesmanPassword', data: _str(data) }).post();
  },
  // 查看代理商信息
  findByUserId (data) {
    return $http({ url: '/zpbranch/findByUserId', data: _str(data) }).post();
  },
  // 回显地址
  selectLocation (data) {
    return $http({ url: '/zpuser/selectLocationCode', data: _str(data) }).post();
  },
  // 查看代理商金额明细
  branchInComeByPage (data) {
    return $http({ url: '/zpbranch/branchInComeByPage', data: _str(data) }).post();
  },
  // 查看代理商金额明细详情
  getUserBranch (data) {
    return $http({ url: '/zpbranch/getUserBranch', data: _str(data) }).post();
  },
  // 查看扫码成功
  orderStateByNumber (data) {
    return $http({ url: '/zjAggregatePayment/orderStateByNumber', data: _str(data) }).post();
  },
  // 查看代理商积分详情
  getUserIntegral (data) {
    return $http({ url: '/integral/getUserIntegral', data: _str(data) }).post();
  },
  // 查看代理商积分
  branchIntegralByPage (data) {
    return $http({ url: '/zpbranch/branchIntegralByPage', data: _str(data) }).post();
  },
  // 查询分公司股东信息
  findByLingTouList (data) {
    return $http({ url: '/zpbranch/findByLingTouList', data: _str(data) }).post();
  },
  // 查看公司对公账号
  findBranchBank (data) {
    return $http({ url: '/zpbranch/findBranchBank', data: _str(data) }).post();
  },
  // 绑定公司公户账号
  updateBranchBank (data) {
    return $http({ url: '/zpbranch/updateBranchBank', data: _str(data) }).post();
  },
  // 代理商提现
  branchWithdraw (data) {
    return $http({ url: '/zpbranch/branchWithdraw', data: _str(data) }).post();
  },
  // 校验用户身份是否为分公司
  zpUserIdentityVerification (data) {
    return $http({ url: '/zpbranch/zpUserIdentityVerification', data: _str(data), _isAll }).post();
  },
  // 我的水机列表
  commodityList (data) {
    return $http({ url: '/zpshopcommodity/commodityList', data: _str(data) }).post();
  },
  // 用户忘记密码
  forgetPassword (data) {
    return $http({ url: '/zpuser/forgetPassword', data: _str(data) }).post();
  },
  // 验证手机号码是否存在
  isExit (data) {
    return $http({ url: '/zpuser/zpValidPhoneIsEmpty', data: _str(data), _isAll }).post();
  },
  ProvinceList (data) {
    return $http({ url: '/zplocation/findByAll', data: _str(data) }).post();
  },
  // 新注册验证码
  sendSmsVerifiers (data) {
    return $http({ url: '/zpsms/sendSmsVerifiers', data: _str(data) }).post();
  },
  // 测试列表
  testList (data) {
    data.wholesaleSellId = 108441;
    return $http({ url: 'http://zdyh-test.coloursecret.com/zdyh-web/wholesale/queryWholesaleList', data: _str(data), isCustomUrl }).post();
  },
  // 获取积分兑换地址
  getIntegralUrl (data) {
    return $http({ url: '/zpuser/getIntegralUrl', data: _str(data) }).post();
  },
  ZpPartner (data) {
    return $http({ url: '/zpuserwithdraw/getZpPartnerById', data: _str(data) }).post();
  },
  ZpWithdraw (data) {
    return $http({ url: '/zpuserwithdraw/getZpWithdrawById', data: _str(data) }).post();
  },
  // 联系信息
  contactInfo () {
    return $http({ url: '/zpuser/getBottomMsg' }).post();
  },
  // 用户协议
  agreement () {
    return $http({ url: 'http://yinshuiji.app.xiaozhuschool.com/Wxsite/home/agreement', isCustomUrl }).post();
  },
  // 查看全部会议
  meetingListAll () {
    return $http({ url: '/api/meeting/listAll' }).post();
  },
  // 查看是否报名
  meetingGetMyQrCode (data) {
    return $http({ url: '/api/meeting/getMyQrCode', data: _str(data) }).post();
  },
  // 查看是否报名
  isExMeeting (data) {
    return $http({ url: '/api/meeting/isExMeeting', data: _str(data) }).post();
  },
  // 报名会议
  meetingInsert (data) {
    return $http({ url: '/api/meeting/insert', data: _str(data) }).post();
  },
  // 一封家书
  meetingFindLetter () {
    return $http({ url: '/api/meeting/findLetter' }).post();
  },
  // 协议
  findProtocol () {
    return $http({ url: '/api/meeting/findProtocol' }).post();
  },
  // 查看会议信息
  meetingGetSignUpInfo (data) {
    return $http({ url: '/api/meeting/getSignUpInfo', data: _str(data) }).post();
  },
  // 出入会场
  meetingInsertLog (data) {
    return $http({ url: '/api/meeting/insertLog', data: _str(data) }).post();
  },
  // 全部退场
  meetingClearAll (data) {
    return $http({ url: '/api/meeting/clearAll', data: _str(data) }).post();
  },
  // 查询会议详情
  meetingGetMeetingInfo (data) {
    return $http({ url: '/api/meeting/getMeetingInfo', data: _str(data) }).post();
  }
};

export default config;

export const install = Vue => {
  Vue.prototype.$fatch = config;
};



// WEBPACK FOOTER //
// ./src/utils/fatch.js